import {writable} from 'svelte/store';
import {ROUTE_TYPE} from "../lib/constants";

let transfersObject = {
    list: null,
    total: 0,
    selectedId: null,
    statusId: '', // due to Svelte bug on select control!!
    page: 1,

    search: {
        transfer_from: null,
        transfer_to: null,
        status_id: '',
        route_type: '',
        fullname: '',
        room_no: '',
        flight_no: '',
        driver_id: null,
        location_id: null,
        department_id: null,
        offset: 0,
        limit: null,
        sort_field: null,
        sort_way: null,
    },

    driver: null,
    location: null,
    department: null,
    changed: false,
    scrollY: null,
};

const {get, set, update, subscribe} = writable(transfersObject);

const transfers = {
    set,
    update,
    subscribe,

    clearSearch: () => {
        transfers.update(obj => {
            obj.statusId = '';
            obj.driver = null;
            obj.location = null;
            obj.department = null;

            obj.search.status_id = '';
            obj.search.route_type = '';
            obj.search.fullname = '';
            obj.search.room_no = '';
            obj.search.flight_no = '';
            obj.search.driver_id = null;
            obj.search.location_id = null;
            obj.search.department_id = null;
            obj.search.offset = 0;

            obj.page = 1;
            return obj;
        });
    },
    isTour: id => {
        let item = transfersObject.list.find(x => x.id == id);
        if (item) {
            return item.route_type ==  ROUTE_TYPE.TOUR;
        }
        return false;
    },
}

export default transfers;